<div class="inputgroup">
  <input class="searchinput" type="text" placeholder="{{'Find by name' | translate }}" [(ngModel)]="Data.searchFilter" (input)="onFilterChange()" />
  <div class="searchtype dropdown dropclick">
    <img src="/assets/icons/search-by-name_gray.svg" *ngIf="Data.searchType == ObjectFilterType.Name" />
    <img src="/assets/icons/search-by-IMEI_gray.svg" *ngIf="Data.searchType == ObjectFilterType.IMEI" />
    <img src="/assets/icons/search-by-phone_gray.svg" *ngIf="Data.searchType == ObjectFilterType.Phone" />
    <img src="/assets/icons/search-by-vincode_gray.svg" *ngIf="Data.searchType == ObjectFilterType.Equipment" />
    <ul>
      <li id="NameFilter" (click)="selectFilter(ObjectFilterType.Name)" [class.active]="Data.searchType == ObjectFilterType.Name">
        <span>
          <img src="/assets/icons/search-by-name_gray.svg" />
        </span>{{'By name' | translate }}
      </li>
      <li id="IMEIFilter" (click)="selectFilter(ObjectFilterType.IMEI)" [class.active]="Data.searchType == ObjectFilterType.IMEI">
        <span>
          <img src="/assets/icons/search-by-IMEI_gray.svg" />
        </span>{{'By IMEI/ID' | translate }}
      </li>
      <li id="PhoneFilter" (click)="selectFilter(ObjectFilterType.Phone)" [class.active]="Data.searchType == ObjectFilterType.Phone">
        <span>
          <img src="/assets/icons/search-by-phone_gray.svg" />
        </span>{{'By phone number' | translate }}
      </li>
      <li id="EqTypeFilter" (click)="selectFilter(ObjectFilterType.Equipment)" [class.active]="Data.searchType == ObjectFilterType.Equipment">
        <span>
          <img src="/assets/icons/search-by-vincode_gray.svg" />
        </span>{{'By device type' | translate }}
      </li>
    </ul>
  </div>
</div>
